import React from "react";
import Message from "../../components/Message/Message";

const Messages: React.FC = () => {
  return (
    <div>
      <Message
        title="Work in progress"
        description="This page is not currently accessible but congratulation for finding it"
      />
    </div>
  );
};

export default Messages;
